import { Button } from '@cian/ui-kit';

import { type FC } from 'react';

type GoToButtonProps = {
  buttonText: string | null;
};

export const GoToButton: FC<GoToButtonProps> = props => {
  const { buttonText } = props;

  const buttonTitle = buttonText || 'Узнать подробнее';

  return (
    <Button size="XS" theme="fill_secondary">
      {buttonTitle}
    </Button>
  );
};
